<!-- -->
<template>
  <qc-container :title="addRow.id?'编辑':'新增'+'运费模板'">
    <el-form class="mt30" ref="ruleForm" :model="addRow"  label-width="120px" >
      <!--      <form-item-rule v-if="addType==1" label="供应商" prop="orgId">
              <el-select  v-model="addRow.orgId" placeholder="请选择供应商">
                <el-option v-for="item in shopList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </form-item-rule>-->
      <form-item-rule label="模板名称" prop="name">
        <el-input  class="w300"  v-model="addRow.name"  placeholder="请输入模板名称"  ></el-input>
      </form-item-rule>
      <form-item-rule label="承诺" prop="sendTime">
        <el-input-number v-model="addRow.sendTime" :min="1" class="w100" :controls="false"/>
        <span class="ml5 mr5">小时内发货</span>
      </form-item-rule>
      <!--      <form-item-rule label="发货地区" prop="sendArea">
              <city @city="cityChange" :desc="sendArea"></city>
            </form-item-rule>-->
      <form-item-rule v-if="!addRow.id" label="运费设置" prop="type">
        <el-radio-group v-model="addRow.type" @input="changeType">
          <el-radio-button :label="2">卖家承担</el-radio-button>
          <el-radio-button :label="0">自定义运费</el-radio-button>
        </el-radio-group>
      </form-item-rule>
      <el-form-item v-else="" label="运费设置">
        {{['自定义运费','固定运费','卖家承担'][addRow.type]}}
      </el-form-item>
      <template v-if="addRow.type==0" >
        <form-item-rule label="计价方式" prop="moneyType">
          <el-radio-group v-model="addRow.moneyType">
            <el-radio-button :label="0">按件数</el-radio-button>
            <el-radio-button :label="1">按重量</el-radio-button>
            <el-radio-button :label="2">按距离</el-radio-button>
          </el-radio-group>
        </form-item-rule>
        <form-item-rule label="收费价格" prop="moneyType">
          <el-input-number v-model="addRow.count" :min="1" class="w100" :controls="false"/>
          <span class="ml5 mr5">{{typeArr[addRow.moneyType]}}以内</span>
          <el-input-number v-model="addRow.money" :min="0" class="w100" :controls="false"/>
          <span class="ml5 mr5">元，每增加</span>
          <el-input-number v-model="addRow.addCount" :min="1" class="w100" :controls="false"/>
          <span class="ml5 mr5">{{typeArr[addRow.moneyType]}}，增加运费</span>
          <el-input-number v-model="addRow.addMoney" :min="0" class="w100" :controls="false"/>
          <span class="ml5 mr5">元</span>
        </form-item-rule>
      </template>
      <form-item-rule v-else-if="addRow.type==1" label="运费金额" prop="money">
        <el-input-number v-model="addRow.money"  class="w100" :controls="false"/>元
      </form-item-rule>
      <form-item-rule label="是否默认" prop="isDefault">
        <el-switch v-model="addRow.isDefault" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
      </form-item-rule>

      <el-tabs class="p30" v-model="activeName">
        <!--        <el-tab-pane v-if="addRow.type===0" label="指定地区运费" name="0">
                  <div class="flex-between">
                    <div>除指定地区外，其余地区运费采用：“默认运费”</div>
                    <div>
                      <el-button @click="doDelete(0)">删除</el-button>
                      <el-button @click="addArea()">添加地区</el-button>
                    </div>
                  </div>
                  <el-table :data="ruleList0" @selection-change="value=>selectItem0=value" style="width: 100%">
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column label="运送地区" >
                      <template slot-scope="scope">
                          <span v-for="(item,index) in scope.row.itemList">
                            {{item.area}}
                            <template v-if="index!==scope.row.itemList.length-1">、</template>
                          </span>
                      </template>
                    </el-table-column>
                    <el-table-column label="计费规则" width="700">
                      <template slot-scope="scope">
                        <el-input-number v-model="scope.row.count" :min="1" class="w100" :controls="false"/>
                        {{typeArr[addRow.moneyType]}}以内
                        <el-input-number v-model="scope.row.money" :min="0" class="w100" :controls="false"/>
                        元，每增加
                        <el-input-number v-model="scope.row.addCount" :min="1" class="w100" :controls="false"/>
                        {{typeArr[addRow.moneyType]}}，增加运费
                        <el-input-number v-model="scope.row.addMoney" :min="0" class="w100" :controls="false"/>
                        元
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200">
                      <template slot-scope="scope">
                        <el-button @click="ruleList0.splice(scope.$index,1)">删除</el-button>
                        <el-button @click="editArea(scope.row.itemList,scope.$index)">编辑地区</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>
                <el-tab-pane label="指定条件包邮" name="1">
                  <div class="flex-between">
                    <div>运送地区、计费规则都可自行编辑</div>
                    <div>
                      <el-button @click="doDelete(1)">删除</el-button>
                      <el-button @click="addArea()">添加地区</el-button>
                    </div>
                  </div>
                  <el-table @selection-change="value=>selectItem1=value" :data="ruleList1" style="width: 100%">
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column label="运送地区" >
                      <template slot-scope="scope">
                          <span v-for="(item,index) in scope.row.itemList">
                            {{item.area}}
                            <template v-if="index!==scope.row.itemList.length-1">、</template>
                          </span>
                      </template>
                    </el-table-column>
                    <el-table-column label="计费规则" width="700">
                      <template slot-scope="scope">
                        满
                        <el-input-number v-model="scope.row.money" :min="1" class="w100" :controls="false"/>
                        <el-select v-model="scope.row.fullType" class="w100">
                          <el-option label="元" :value="0"></el-option>
                          <el-option label="件" :value="1"></el-option>
                        </el-select>
                        包邮
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200">
                      <template slot-scope="scope">
                        <el-button @click="ruleList1.splice(scope.$index,1)">删除</el-button>
                        <el-button @click="editArea(scope.row.itemList,scope.$index)">编辑地区</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-tab-pane>-->
        <el-tab-pane label="不配送区域" name="2">
          <div class="flex-between">
            <div>限制区域的用户无法购买商品</div>
          </div>
          <el-table :data="ruleList2" style="width: 100%">
            <el-table-column label="不配送区域" >
              <template #default="scope">
                    <span v-for="(item,index) in scope.row.itemList">
                      {{item.area}}
                      <template v-if="index!==scope.row.itemList.length-1">、</template>
                    </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="200">
              <template #default="scope">
                <el-button @click="editArea(scope.row.itemList,scope.$index)">编辑地区</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>


      <div class="footer-box">
        <el-button @click="returnLast">返回</el-button>
        <el-button  type="primary" @click="submitForm('ruleForm')">保存</el-button>
      </div>
    </el-form>


    <el-dialog title="编辑地区" v-model="areaShow" width="600px" :before-close="()=>areaShow=false">
      <el-form  label-width="120px" >
        <el-form-item label="地区">
          <div class="flex">
            <select-city ref="city" v-model="city"></select-city>
            <span @click="addCity" class="primary ml10 cp">+添加</span>
          </div>
        </el-form-item>
        <el-form-item label="已选地区" >
          <el-tag class="mr10" v-for="(item,index) in itemList" :key="item.code" closable @close="itemList.splice(index,1)">{{item.area}}</el-tag>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
          <el-button @click="areaShow = false">取 消</el-button>
          <el-button type="primary" @click="saveItemList()">确 定</el-button>
        </span>
    </el-dialog>
  </qc-container>
</template>

<script>
import QcContainer from "@/components/el/layout/qc-container";
import FormItemRule from "@/components/el/form-item-rule";
import City from "@/components/dict/City";
import SelectCity from "@/components/dict/SelectCity";
export default {
  name: "freight-add",
  components: {SelectCity, City, FormItemRule, QcContainer},
  data() {
    return {
      addRow:{name:"",sendTime:1,sendArea:"",type:2,moneyType:0,count:null,money:null,addCount:null,addMoney:null,ruleList:[],isDefault:0,shopType:1},
      typeArr:['件','kg','km'],
      activeName:"2",
      ruleList0:[],
      ruleList1:[],
      ruleList2:[{itemList:[],count:null,money:null,addCount:null,addMoney:null,type:2,fullType:0}],
      editIndex:null,
      itemList:[],
      areaShow:false,
      city:null,
      sendArea:null,
      selectItem0:[],
      selectItem1:[],
      addType:0,
    }
  },
  mixins: [tableBase],
  methods: {
    cityChange(city){
      this.addRow.areaCode = city.code;
      this.addRow.sendArea = city.pName+city.cName+city.dName;
    },
    addArea(){
      this.editIndex = null;
      this.itemList = [];
      this.areaShow = true;
      this.city = null;
    },
    editArea(itemList,index){
      this.editIndex = index;
      this.itemList = itemList;
      this.areaShow = true;
      this.city = null;
    },
    addCity(){
      if(!this.city){
        this.messageError("请选择地区");
      }else{
        let add = true;
        this.itemList.forEach(row=>{
          if(row.code===this.city.value){
            add = false
          }
        })
        if(add){
          this['ruleList'+this.activeName].forEach(rule=>{
            rule.itemList.forEach(row=>{
              if(row.code===this.city.value){
                add = false
              }
            })
          })
        }
        if(add){
          this.itemList.push({code:this.city.value,area:this.city.label});
        }else{
          this.messageError("地区已添加");
        }
      }
    },
    saveItemList(){
      if(this.itemList.length===0){
        this.messageError("请添加地区");
        return;
      }
      if($.isEmpty(this.editIndex)){
        this['ruleList'+this.activeName].push({itemList:this.itemList,count:null,money:null,addCount:null,addMoney:null,type:this.activeName,fullType:0})
      }else{
        this['ruleList'+this.activeName][this.editIndex].itemList = this.itemList;
      }
      this.areaShow = false;
      this.itemList = [];
      this.editIndex = null;
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addRow.ruleList = [];
          this.addRow.ruleList.pushAll(this.ruleList0);
          this.addRow.ruleList.pushAll(this.ruleList1);
          this.addRow.ruleList.pushAll(this.ruleList2);
          this.addRow.contentType = _CONTENT_TYPE_JSON;
          this.simplePost("/api/mgr/business/freight/addOrUpdate", this.addRow, () => {
            this.returnLast();
          });
        }
      });
    },
    doDelete(type){
      let list = this['selectItem'+type];
      if(list.length===0){
        this.selectOneWarn();
        return;
      }
      list.forEach(row=>{
        this['ruleList'+type].remove(row);
      })
      this['selectItem'+type] = [];
    },
    changeType(value){
      /*if(value===0){
        this.activeName = "0";
      }else{
        this.activeName = "1";
      }*/
      this.activeName = "2";
    },
    loadShopList(){
      this.simplePost("/api/mgr/business/shop/getAllShop",null,result=>{
        this.shopList = result.data;
      },false)
    },
  },
  mounted() {
    /*this.addType = this.$route.query.type || 0 ;
    if(this.addType==1){
      this.loadShopList();
    }*/
    this.addRow.shopType = this.$route.query.type || 0;
    if(this.$route.query.id){
      this.simpleGet("/api/mgr/business/freight/detail",{id:this.$route.query.id},result=>{
        this.addRow = result.data;
        this.ruleList2 = [];
        result.data.ruleList.forEach(row=>{
          this['ruleList'+row.type].push(row);
        })
        this.sendArea = result.data.sendArea;
        if(this.addRow.type===1){
          this.activeName = "1";
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.footer-box{
  text-align: center;
  padding: 10px 0;
}
</style>
